import React from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Icon from '@material-ui/core/Icon';
import { Link } from "react-router-dom";
import { generalS } from "../../strings/general";

export default function DesktopMenu({language, authenticated, context}) {
  return (
    <nav className={"desktop-menu"}>
      <ul className={"desktop-menu-list"}>
        <li className={"desktop-menu-list-item"}>
          <Link to="/">
            <span className={"desktop-menu-link"}>{generalS.home[language]}</span>
          </Link>
        </li>
        <li className={"desktop-menu-list-item"}>
          <Link to="">
            <span className={"desktop-menu-link"}>{generalS.news[language]}</span>
          </Link>
          <div className={"desktop-sub-menu"}>
            <ul className={"desktop-sub-menu-list"}>
              <li className={"desktop-sub-menu-list-item"}>
                <Link to="/projects">
                  <span className={"desktop-sub-menu-link"}>{generalS.latestProject[language]}</span>
                </Link>
              </li>
            </ul>
          </div>
        </li>
        <li className={"desktop-menu-list-item"}>
          <Link to="/product">
            <span className={"desktop-menu-link"}>{generalS.product[language]}</span>
          </Link>
        </li>
        <li className={"desktop-menu-list-item"}>
          <Link to="/about">
            <span className={"desktop-menu-link"}>{generalS.about[language]}</span>
          </Link>
        </li>
        {authenticated ? 
          <li className={"desktop-menu-list-item"}>
            <Link to="/">
              <span className={"desktop-menu-link"}>{generalS.cpanel[language]}</span>
            </Link>
            <div className={"desktop-sub-menu"}>
              <ul className={"desktop-sub-menu-list"}>
                <li className={"desktop-sub-menu-list-item"}>
                  <Link to="/post">
                    <span className={"desktop-sub-menu-link"}>{generalS.post[language]}</span>
                  </Link>
                </li>
                <li className={"desktop-sub-menu-list-item"}>
                  <Link to="/user">
                    <span className={"desktop-sub-menu-link"}>{generalS.userManagment[language]}</span>
                  </Link>
                </li>
                <li className={"desktop-sub-menu-list-item"}>
                  <Link to="/settings">
                    <span className={"desktop-sub-menu-link"}>{generalS.settings[language]}</span>
                  </Link>
                </li>
                <li className={"desktop-sub-menu-list-item"} onClick={() => context.logout()}>
                  <span className={"desktop-sub-menu-link"}>{generalS.logout[language]}</span>
                </li>
              </ul>
            </div>
          </li>
        :("")}
      </ul>
    </nav>
  );
}
